import { makeStyles, tokens } from '@fluentui/react-components';

const GRID_COLUMNS = '1fr 140px 1fr 1fr 32px';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
  },

  header: {
    display: 'grid',
    gridTemplateColumns: GRID_COLUMNS,
    gap: tokens.spacingHorizontalS,
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
    fontWeight: tokens.fontWeightSemibold,
    paddingTop: tokens.spacingVerticalXS,
  },

  row: {
    display: 'grid',
    gridTemplateColumns: GRID_COLUMNS,
    gap: tokens.spacingHorizontalS,
    alignItems: 'start',
    // Let the 1fr columns shrink below the inputs' intrinsic width so the grid
    // never overflows a narrow container.
    '& > *': {
      minWidth: 0,
    },
  },

  empty: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
    fontStyle: 'italic',
  },
});
